import { render, staticRenderFns } from "./CRUDExpandableRow.vue?vue&type=template&id=d17ad38e&"
import script from "./CRUDExpandableRow.vue?vue&type=script&lang=js&"
export * from "./CRUDExpandableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports